"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LINK_CATEGORY_KEY = 'base';
exports.LINK_COMPONENT_KEY = 'link';